import React from "react";
import { useSelector } from "react-redux";
import { Calendar,CircleCheck, X } from "lucide-react";
import { Badge, Divider, Card } from "antd";
import EmployeeProfile from "components/card/EmployeeProfile";
import { formatDateTimeOrNull } from "utils/index";

const LeaveRequestsCard = () => {
  const actionRequiredData = useSelector((state) => state.dashboard.clientActionRequiredSummary.data);

    const leaveRequests = actionRequiredData?.pendingLeaveList;
    if (!leaveRequests || leaveRequests?.length === 0) return null;  

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 mb-2">
        <Calendar className="w-3.5 h-3.5 text-blue-600 dark:text-blue-500"/>
        <h3 className="text-[12px] title-text">
          Leave Requests
        </h3>
        <Badge
          count={leaveRequests.length}
          size="small"
          style={{
            backgroundColor: "rgb(43 127 255)",
            color: "#ffffff",
            border: "none",
            fontSize: "9px",
          }}
        />
      </div>

      {leaveRequests.map(
        (leave) => (
          <Card
            key={leave?.lve_id}
            className="rounded-2xl border pr-2 space-y-2 dark-mode-card"
          >
            <div className="flex justify-between items-start">
              <span
                className={`absolute right-5 text-[10px] status-indicator h-4  ${leave?.lve_priority}`}>
                {leave?.lve_priority}
              </span>

              <div className="flex items-center space-x-3">
                <EmployeeProfile 
                  record={leave?.lve_employee}
                  withEmpId={false}
                  withEmpJobTitle={true}
                  nameInitialBg="bg-green-50"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-1 my-2">
              <div>
                <p className="text-xs muted-text mb-1">Type</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs title-text">{leave?.lve_type_name}</span> 
                  {leave?.lve_is_unpaid == 1 && <span className="rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-900/30 dark:text-red-300">LWOP</span>}
                </div>
              </div>
              <div>
                <p className="text-xs muted-text mb-1">Duration</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs title-text">
                    {leave?.lve_duration} day{leave?.lve_duration > 1 ? "s" : ""}
                  </span>
                </div>
              </div>
              <div>
                <p className="text-xs muted-text mb-1">Start Date</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs title-text">{formatDateTimeOrNull(leave?.lve_date_from, 'YYYY-MM-DD hh:ss')}</span>
                </div>
              </div>
              <div>
                <p className="text-xs muted-text mb-1">End Date</p>
                <div className="flex items-center gap-1">
                  <span className="text-xs title-text">{formatDateTimeOrNull(leave?.lve_date_to, 'YYYY-MM-DD hh:ss')}</span>
                </div>
              </div>
              {leave?.lve_is_undertime == 1 &&
              <>
                <div>
                  <p className="text-xs muted-text mb-1">Is Undertime</p>
                  <div className="flex items-center gap-1">
                    <span className="text-xs title-text">Yes</span>
                  </div>
                </div>
                <div>
                  <p className="text-xs muted-text mb-1">Undertime Hours</p>
                  <div className="flex items-center gap-1">
                    <span className="text-xs title-text">{leave?.lve_undertime_duration}</span>
                  </div>
                </div>
                <div>
                  <p className="text-xs muted-text mb-1">Schedule</p>
                  <div className="flex items-center gap-1">
                    <span className="text-xs title-text">{leave?.lve_undertime_from}</span>
                  </div>
                </div>
                <div>
                  <p className="text-xs muted-text mb-1">Actual</p>
                  <div className="flex items-center gap-1">
                    <span className="text-xs title-text">{leave?.lve_undertime_to}</span>
                  </div>
                </div>
              </>
              }
            </div>

            <div>
              <p className="text-xs muted-text mb-1">Reason</p>
              <p className="text-xs title-text">{leave?.lve_reason}</p>
            </div>

            <Divider
              style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }}
            />

            <div className="flex gap-3 justify-between">
              <div className="inline-flex gap-1">
                <p className="text-xs muted-text">Submitted: </p>
                <div className="flex gap-1">
                  <span className="text-xs title-text">{formatDateTimeOrNull(leave?.created_at, 'YYYY-MM-DD hh:ss')}</span>
                </div>
              </div>
              <div className="inline-flex gap-2">
                <button
                  className="w-full rounded-xl border px-2 py-0.5 flex items-center gap-1 text-[11px] title-text"
                >
                  <X size={12} /> Reject
                </button>
                <button
                  className="w-full rounded-xl bg-green-700 border px-2 py-0.5 flex items-center gap-1 text-[11px] text-white"
                >
                  <CircleCheck size={12} /> Approve
                </button>
              </div>
            </div>
          </Card>
        )
      )}
    </div>
  );
};

export default LeaveRequestsCard;
